import { render, staticRenderFns } from "./MyAddStep.vue?vue&type=template&id=6990f220&scoped=true"
import script from "./MyAddStep.vue?vue&type=script&lang=js"
export * from "./MyAddStep.vue?vue&type=script&lang=js"
import style0 from "./MyAddStep.vue?vue&type=style&index=0&id=6990f220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990f220",
  null
  
)

export default component.exports